<template lang="pug">
  VContainer.not-connected__container
    h1.not-connected__title(
      :class="{'is-da': isPublicSaleLive}"
      tabindex="0"
    )
      .not-connected__logo(v-if="isMobile")
        IOLogo
        span.t--yellow {{ saleTypeText }}
      template(v-else)
        span.t--yellow Imaginary Ones
        span {{ saleTypeText }}


      transition(name="fade")
        VBtn.v-btn--connect(
          v-if="!isMobile"
          x-large
          dark
          rounded
          :elevation="0"
          @click="connectWallet"
        ) Connect Wallet
</template>

<script>
import accountMixin from '@/mixins/account-mixins';
import saleMixin from '@/mixins/sale-mixins';

export default {
  name: 'MintNotConnected',
  components: {
    IOLogo: () => import('@/components/IOLogo'),
  },
  props: {
    isMobile: { type: Boolean, default: false },
  },
  mixins: [accountMixin, saleMixin],
  computed: {
    saleTypeText() {
      return `${
        this.isPublicSaleLive ? (this.isMobile ? 'DA' : 'Dutch Auction') : 'Whitelist'
      } Sale`;
    },
  },
};
</script>

<style lang="scss">
.not-connected__title {
  font-family: $font-primary;
  color: $white;
  font-size: 3rem;
  font-weight: 900;
  line-height: 1;
  text-transform: uppercase;

  @include small-mobile {
    font-size: 2.125rem;
  }

  @include tablet {
    font-size: 4rem;
  }

  @include desktop {
    font-size: 4.5rem;
  }

  @include wide-desktop {
    font-size: 7rem;
  }

  @include big {
    font-size: 9.5rem;
  }

  &.is-da {
    @include tablet {
      font-size: 2.25rem;
    }

    @include desktop {
      font-size: 3.5rem;
    }

    @include wide-desktop {
      font-size: 5.5rem;
    }

    @include big {
      font-size: 7.5rem;
    }
  }

  span {
    display: block;
    position: relative;

    @include mobile {
      font-size: 1.75rem;
      margin-top: 10px;
    }
  }
}

.v-btn--connect {
  @include smallest() {
    margin-top: 20px;
  }
}
</style>
